const NotFound = () => {
  return <div className="text-center text-[32px] font-bold h-full flex items-center justify-center w-full">404</div>;
};

export default NotFound;
